import VendorSearchResultsHtml from '../../app-lite/vendors/templates/vendors.search.results.html';

export function HsySettingsCtrl (
  $uibModal,
  $state,
  $scope,
  $translate,
  confirm,
  integrations,
  messages,
  streamSearch,
  Vendor,
  workshopAPI
) {
  $scope.integrations = integrations;
  $scope.loaded = true;

  $scope.save = function () {
    workshopAPI.patch('/company_integrations', $scope.integrations, 'company_integration').then(function () {
      messages.show($translate.instant('JS_SPACE.MESSAGES.SAVED.SAVE_SUCCESSFUL'), 'success');
    }).then(function() {
      $state.reload();
    }, function (data) {
        messages.error(data);
    });
  };

  $scope.activate = function () {
    confirm.generic($translate.instant('JS_SPACE.INTEGRATIONS.ACTIVATE', {name:"HSY"}))
      .then(function () {
        return workshopAPI.get('/company_integration/add_hsy');
      }).then(function () {
        messages.show($translate.instant('JS_SPACE.INTEGRATIONS.ACTIVATED', {name:"HSY"}), 'success');
        $state.reload();
      }, function (err) {
        messages.error(err);
      });
  };

  $scope.remove = function () {
    confirm.generic($translate.instant('JS_SPACE.INTEGRATIONS.REMOVE', {name:"HSY"}))
      .then(function () {
        return workshopAPI.get('/company_integration/remove_hsy');
      }).then(function () {
        messages.show($translate.instant('JS_SPACE.INTEGRATIONS.REMOVED', {name:"HSY"}), 'success');
        $state.reload();
      }, function (err) {
        messages.error(err);
      });
  };

  $scope.hsyVendor = {
    list: [],
    selected: {
      id: $scope.integrations.hsy_vendor_id,
      company_name: $scope.integrations.hsy_vendor_name,
    },
    search (typed) {
      return streamSearch.search('vendors', typed).then(data => {
        return $scope.hsyVendor.list.concat(data);
      });
    },
    new () {
      Vendor.quickAdd().then(vendor => {
        $scope.integrations.hsy_vendor_id   = vendor.id;
        $scope.integrations.hsy_vendor_name = vendor.company_name;
        $scope.hsyVendor.selected           = vendor;

        messages.show($translate.instant('JS_SPACE.INTEGRATIONS.SUPPLIER_FOR_INTEGRATION', {name:"HSY"}), 'success');
      });
    },
    choose (vendor) {
      $scope.integrations.hsy_vendor_id   = vendor.id;
      $scope.integrations.hsy_vendor_name = vendor.company_name;
    },
    format (vendor) {
      return vendor ? vendor.company_name: '';
    },
    templateUrl: VendorSearchResultsHtml
  };
}
